import { useQuery } from 'react-query'

import { CREDIT_CARD_PROVIDER_OPTIONS_QUERY_KEY } from './creditCardProviderOptionsQueryKey'
import { vendorRepository } from '../../data-access/repositories/VendorRepository'

export const useCreditCardProviderSelect = () => {
  const { data, isFetching } = useQuery({
    queryKey: CREDIT_CARD_PROVIDER_OPTIONS_QUERY_KEY,
    queryFn: () => vendorRepository.listCreditCardProviders(),
    cacheTime: Infinity,
  })

  return {
    data: {
      providers: data ?? [],
    },
    states: {
      isFetching,
    },
  }
}
